import { fields } from './internal/fields';
export const set = (...opts) => {
    const options = {};
    for (let i = opts.length; i--;) {
        const op = opts[i];
        if (typeof op === 'function') {
            op(options);
        }
        else {
            Object.assign(options, op);
        }
    }
    return fields(options);
};
